import { render, staticRenderFns } from "./TypeConfigCrud.vue?vue&type=template&id=bfcfb6d4"
import script from "./TypeConfigCrud.vue?vue&type=script&lang=js"
export * from "./TypeConfigCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports